import {Col, Nav, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import * as PropTypes from "prop-types";


MiniNavigation.propTypes = {
    activeSection: PropTypes.string,
    sections: PropTypes.array,
    actionsLeft: PropTypes.array,
    actionsRight: PropTypes.object,
    defaultSection: PropTypes.string,
};

export function MiniNavigation(props) {
    const headerSize = 160; // Висота навігаційного бару

    const [activeSection, setActiveSection] = useState(props.defaultSection);


    useEffect(() => {
        const handleScroll = () => {

            if (props.sections) {

                for (let section of props.sections) {
                    const element = section.ref.current;
                    if (element) {
                        const rect = element.getBoundingClientRect();

                        // Додаємо зміщення до верхньої позиції елементу для врахування навігаційного бару
                        const elementTopWithOffset = rect.top - headerSize;

                        // Якщо елемент знаходиться в зоні видимості, враховуючи зміщення
                        if (elementTopWithOffset <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                            setActiveSection(section.name);
                            break;
                        }
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    // Scroll to section on menu click
    const scrollToSection = (sectionRef) => {
        // Отримуємо позицію елементу відносно документа
        const elementPosition = sectionRef.current.getBoundingClientRect().top + window.pageYOffset;


        // Скролимо до елементу з врахуванням зміщення (offset)
        window.scrollTo({
            top: elementPosition - headerSize,
            behavior: "smooth"
        });
    };


    return <>
        <Row className="sticky-header-2 bg-white p-2 ">
            <Col>
                <Nav as="ul" className="nav mini-nav">
                    {props.actionsLeft && props.actionsLeft}

                    {props.sections && props.sections.map(section =>
                        (<>
                            <Nav.Item as="li" className={` ${activeSection === section.name ? "active" : ""}`}>
                                <Nav.Link onClick={() => scrollToSection(section.ref)}>
                                    {section.menu}
                                </Nav.Link>
                            </Nav.Item>
                        </>))
                    }
                    <Nav as="ul" className="ml-auto">
                        {props.actionsRight && props.actionsRight}
                    </Nav>

                </Nav>

            </Col>
        </Row>
    </>;
}